/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const SET_REALM_IDPS_LOADING = 'SET_REALM_IDPS_LOADING';
export const SET_REALM_IDPS = 'SET_REALM_IDPS';
export const SET_IDP_DETAILS = 'SET_IDP_DETAILS';
export const IDP_ERRORS = 'IDP_ERRORS';
export const FETCH_IDP_REQUEST = 'FETCH_IDP_REQUEST';
export const FETCH_IDP_SUCCESS = 'FETCH_IDP_SUCCESS';
export const FETCH_IDP_FAILURE = 'FETCH_IDP_FAILURE';
